<template>
    <div class="flex flex-col items-center justify-center md:w-[760px]">
        <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_ORDERS_PATH}NoConnection.svg`" alt="Error" />

        <div class="text-[#464646] flex flex-col items-center text-center">
            <p class="text-[18px] font-semibold">{{ $t('integration.connection') }}</p>
            <p class="text-base">{{ $t('integration.connectionMsg') }}</p>

            <div class="mt-1">
                <BaseButton variant="outline" size="custom" class="w-[180px] h-8 text-base"
                    @click="goToIntegrationPage">
                    {{ $t('integration.goToIntegration') }} <i class="ri-arrow-right-line text-lg text-[#464646]"></i>
                </BaseButton>
            </div>
        </div>

    </div>
</template>

<script setup>
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_ORDERS_PATH } from "@/config/constants.js";
import { useI18n } from "vue-i18n";
import { getLanguage } from '@/utilities/cookies';
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';

const { t, locale } = useI18n();
locale.value = getLanguage();

const goToIntegrationPage = () => {
    window.location = `/integrations`
}
</script>

<style scoped></style>
